// src/components/ui/Card.js
import React from 'react';
import './ui.css';

const Card = ({
  children,
  title,
  icon: Icon,
  variant = 'solid', // 'solid' ya 'glass'
  className = '',
  style = {},
  onClick,
  iconBg = 'linear-gradient(135deg, #E0F2FE, #7DD3FC)',
  iconColor = '#0284C7',
  noPadding = false
}) => {

  const isGlass = variant === 'glass';

  return (
    <div
      className={`${className}`}
      style={{
        background: isGlass ? 'rgba(255, 255, 255, 0.75)' : '#FFFFFF',
        backdropFilter: isGlass ? 'blur(24px) saturate(180%)' : 'none',
        WebkitBackdropFilter: isGlass ? 'blur(24px) saturate(180%)' : 'none',
        borderRadius: '24px',
        padding: noPadding ? '0px' : '20px',
        border: isGlass ? '1px solid rgba(255, 255, 255, 0.6)' : '1px solid #E2E8F0',
        boxShadow: isGlass ? '0 16px 40px rgba(15, 23, 42, 0.04), inset 0 1px 1px rgba(255,255,255,1)' : '0 4px 15px rgba(0, 0, 0, 0.02)',
        cursor: onClick ? 'pointer' : 'default',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        ...style
      }}
      onClick={onClick}
      
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = '0 20px 48px rgba(15, 23, 42, 0.08)';
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = isGlass 
            ? '0 16px 40px rgba(15, 23, 42, 0.04), inset 0 1px 1px rgba(255,255,255,1)' 
            : '0 4px 15px rgba(0, 0, 0, 0.02)';
        }
      }}
    >
      {/* Decorative Vector Glow inside Glass Mode */}
      {isGlass && (
        <div style={{ position: 'absolute', top: '-50px', right: '-50px', width: '100px', height: '100px', background: `radial-gradient(circle, ${iconColor}1A 0%, transparent 70%)`, opacity: 0.15, filter: 'blur(16px)', pointerEvents: 'none' }} />
      )}

      {(title || Icon) && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginBottom: noPadding ? '0' : '16px',
          padding: noPadding ? '16px' : '0 0 12px 0',
          borderBottom: '1px solid rgba(15, 23, 42, 0.05)',
          zIndex: 1
        }}>
          {Icon && (
            <div style={{
              background: iconBg,
              padding: '8px',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: `0 4px 10px ${iconColor}25`
            }}>
              <Icon size={16} color={iconColor} strokeWidth={2.5} />
            </div>
          )}
          {title && (
            <h3 style={{
              fontSize: '11px',
              fontWeight: '900',
              color: '#0F172A',
              margin: 0,
              textTransform: 'uppercase',
              letterSpacing: '0.6px'
            }}>
              {title}
            </h3>
          )}
        </div>
      )}

      <div style={{ flex: 1, zIndex: 1, position: 'relative' }}>
        {children}
      </div>
    </div>
  );
};

export default Card;